export const trustyConstants = {
    states: {
        idle: "idle",
        loading: "loading",
        
        set1Ready: "set1Ready",
        set1Playing: "set1Playing",
        
        intermediateStats: "intermediateStats",
        
        set2Ready: "set2Ready",
        set2Playing: "set2Playing",
        
        paused1: "paused1",
        paused2: "paused2",
        
        gameOver: "gameOver",
        error: "error"
    },
    events: {
        START: "START",
        GUESS: "GUESS",
        TICK: "TICK",
        PAUSE: "PAUSE",
        RESUME: "RESUME",
        RETRY: "RETRY",
        EXIT: "EXIT",
        NEXT_SET: "NEXT_SET"
    },
    actions: {
        initGame: "initGame",
        initSet1: "initSet1",
        initSet2: "initSet2",
        updateScore: "updateScore",
        tickTimer: "tickTimer",
        saveHighScore: "saveHighScore",
        setNextPair: "setNextPair",
        handleError: "handleError"
    }
};
